export const alertTypes = {
  primary: "primary",
  secondary: "secondary",
  info: "info",
  success: "success",
  warning: "warning",
  danger: "danger",
  light: "light",
  dark: "dark",
};
